export const ORDER_CREATE_REQUEST = "ORDER_CREATE_REQUEST";
export const ORDER_CREATE_SUCCESS = "ORDER_CREATE_SUCCESS";
export const ORDER_CREATE_FAIL = "ORDER_CREATE_FAIL";
export const ORDER_CREATE_RESET = "ORDER_CREATE_RESET";

export const LOGGED_USER_ORDER_REQUEST = "LOGGED_USER_ORDER_REQUEST";
export const LOGGED_USER_ORDER_SUCCESS = "LOGGED_USER_ORDER_SUCCESS";
export const LOGGED_USER_ORDER_FAIL = "LOGGED_USER_ORDER_FAIL";


export const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL";

export const CREATE_RAZORPAY_ORDER_REQUEST = "CREATE_RAZORPAY_ORDER_REQUEST" 
export const CREATE_RAZORPAY_ORDER_SUCCESS = "CREATE_RAZORPAY_ORDER_SUCCESS" 
export const CREATE_RAZORPAY_ORDER_FAIL = "CREATE_RAZORPAY_ORDER_FAIL" 

export const ORDER_PAY_REQUEST = "ORDER_PAY_REQUEST";
export const ORDER_PAY_SUCCESS = "ORDER_PAY_SUCCESS";
export const ORDER_PAY_FAIL = "ORDER_PAY_FAIL";
export const ORDER_PAY_RESET = "ORDER_PAY_RESET";

export const ORDER_DELIVER_REQUEST = "ORDER_DELIVER_REQUEST";
export const ORDER_DELIVER_SUCCESS = "ORDER_DELIVER_SUCCESS";
export const ORDER_DELIVER_FAIL = "ORDER_DELIVER_FAIL";
export const ORDER_DELIVER_RESET = "ORDER_DELIVER_RESET";


export const ORDER_LIST_REQUEST = "ORDER_LIST_REQUEST"; 
export const ORDER_LIST_SUCCESS = "ORDER_LIST_SUCCESS"; 
export const ORDER_LIST_FAIL = "ORDER_LIST_FAIL"; 



export const ARTISAN_ORDER_LIST_REQUEST = "ARTISAN_ORDER_LIST_REQUEST";
export const ARTISAN_ORDER_LIST_SUCCESS = "ARTISAN_ORDER_LIST_SUCCESS";
export const ARTISAN_ORDER_LIST_FAIL = "ARTISAN_ORDER_LIST_FAIL"; 